import { CalendarOptions } from '@fullcalendar/core';
import { commonImages } from '@images/common-images';
import { leadImages } from '@images/lead-images';

export class Leads {
  public static beds: any[] = [
    { bed: '1' },
    { bed: '1 + Study' },
    { bed: '2' },
    { bed: '2 + Study' },
    { bed: '3' },
    { bed: '3 + Study' },
    { bed: '4' },
    { bed: '5' },
    { bed: 'Penthouse' },
    { bed: 'Unknown' },
  ];

  public static minPrice = [
    { price: 'Less than $350,000' },
    { price: '$350,000 to $400,000' },
    { price: '$300,000 to $450,000' },
    { price: '$450,000 to $500,000' },
    { price: '$500,000 to $550,000' },
    { price: '$550,000 to $600,000' },
    { price: '$600,000 to $650,000' },
    { price: '$650,000 to $700,000' },
    { price: '$700,000 to $800,000' },
    { price: '$800,000 to $900,000' },
    { price: '$900,000 to $1,000,000' },
    { price: '$1,000,000 to $1,500,000' },
    { price: '$1,500,000 to $2,000,000' },
    { price: '$2,000,000 to $3,000,000' },
    { price: '$3,000,000 to $4,000,000' },
    { price: '$4,000,000 to $5,000,000' },
    { price: 'More than $5,000,000' },
    { price: 'Over $2,000,000 (REA)' },
    { price: 'Rather not say (REA)' },
    { price: 'Unknown' },
  ];

  // Display order for the price-range tags, which the API returns unordered.
  // Both the '$300,000 to $450,000' and '$400,000 to $450,000' tag wordings are in use, so keep them in the same slot.
  public static priceRangeOrder: string[] = [
    'Less than $350,000',
    '$350,000 to $400,000',
    '$300,000 to $450,000',
    '$400,000 to $450,000',
    '$450,000 to $500,000',
    '$500,000 to $550,000',
    '$550,000 to $600,000',
    '$600,000 to $650,000',
    '$650,000 to $700,000',
    '$700,000 to $800,000',
    '$800,000 to $900,000',
    '$900,000 to $1,000,000',
    '$1,000,000 to $1,500,000',
    '$1,500,000 to $2,000,000',
    '$2,000,000 to $3,000,000',
    '$3,000,000 to $4,000,000',
    '$4,000,000 to $5,000,000',
    'More than $5,000,000',
    'Over $2,000,000 (REA)',
    'Rather not say (REA)',
    'Unknown',
  ];

  // Sort price-range tags into priceRangeOrder; anything not in the list falls to the end, alphabetically
  public static sortPriceRange(data: any[]): any[] {
    return [...(data || [])].sort((a, b) => {
      const aIndex = Leads.priceRangeOrder.indexOf(a?.tag_name);
      const bIndex = Leads.priceRangeOrder.indexOf(b?.tag_name);
      if (aIndex === -1 && bIndex === -1) {
        return a?.tag_name > b?.tag_name ? 1 : -1;
      }
      if (aIndex === -1) {
        return 1;
      }
      if (bIndex === -1) {
        return -1;
      }
      return aIndex - bIndex;
    });
  }

  public static hours =['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

  public static minutes = ['00', '15', '30', '45', '---', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

  public static calendar_views = [
    {
      value: 'timeGridDay',
      name: 'Day',
    },
    {
      value: 'timeGridWeek',
      name: 'Week',
    },
    {
      value: 'dayGridMonth',
      name: 'Month',
    },
  ];

  public static calendar_option: CalendarOptions = {
    initialDate: '2022-01-31',
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: '',
    },
    events: [],
    editable: true,
    selectable: true,
    selectMirror: true,
    slotDuration: '01:00:00',
    dayHeaderFormat: { day: 'numeric', weekday: 'short', omitCommas: true },
    titleFormat: { year: 'numeric', month: 'long' },
  };

  public static availablebusy = [
    {
      name: 'Busy',
    },
    {
      name: 'Free',
    },
  ];

  public static available = [
    {
      name: 'private',
    },
    {
      name: 'public',
    },
  ];

  public static task_columns = [
    {
      type: 'text',
      field: 'title',
      column: 'Title',
    },
    {
      type: 'text',
      field: 'jobTypeName',
      column: 'Job Type',
    },
    {
      type: 'text',
      field: 'taskStatusName',
      column: 'Task Status',
    },
    {
      type: 'text',
      field: 'start_date',
      column: 'Start Date',
    },
    {
      type: 'text',
      field: 'due_date',
      column: 'Due Date',
    },
  ];

  public static contactMethods = [
    {
      name: 'Call',
      icon: commonImages?.email_call_icon,
    },
    {
      name: 'Meeting',
      icon: commonImages?.email_user_icon,
    },
    {
      name: 'Deadline',
      icon: leadImages?.flag_icon_v2,
    },
    {
      name: 'Email',
      icon: leadImages?.email_lite_icon,
    },
    {
      name: 'Lunch',
      icon: leadImages?.launch_icon,
    },
  ];

  public static leadCategory: any[] = [
    { name: 'Listing', value: 'listing' },
    { name: 'Project', value: 'project' },
    { name: 'Property', value: 'property' },
    { name: 'Client Requirements', value: 'requirement' },
  ];

  public static ageGroup: any[] = [
    { name: '18-25', value: '18-25' },
    { name: '26-35', value: '26-35' },
    { name: '36-45', value: '36-45' },
    { name: '46-55', value: '46-55' },
    { name: '56+', value: '56+' },
  ];

  public static bathrooms = [
    { bath: 'Any' },
    { bath: '0' },
    { bath: '1+' },
    { bath: '2+' },
    { bath: '3+' },
    { bath: '4+' },
    { bath: '5+' },
    { bath: '6+' },
    { bath: '7+' },
    { bath: '8+' },
    { bath: '9+' },
    { bath: '10+' },
  ];

  public static land_size = [
    { land_size: 'any' },
    { land_size: '100 m²' },
    { land_size: '200 m²' },
    { land_size: '300 m²' },
    { land_size: '400 m²' },
    { land_size: '500 m²' },
    { land_size: '600 m²' },
    { land_size: '700 m²' },
    { land_size: '800 m²' },
    { land_size: '900 m²' },
    { land_size: '1000 m²' },
    { land_size: '1200 m²' },
    { land_size: '1500 m²' },
    { land_size: '1750 m²' },
    { land_size: '2000 m²' },
    { land_size: '3000 m²' },
    { land_size: '4000 m²' },
    { land_size: '5000 m²' },
    { land_size: '1 ha' },
    { land_size: '2 ha' },
    { land_size: '3 ha' },
    { land_size: '4 ha' },
    { land_size: '5 ha' },
    { land_size: '10 ha' },
    { land_size: '20 ha' },
    { land_size: '30 ha' },
    { land_size: '40 ha' },
    { land_size: '50 ha' },
    { land_size: '60 ha' },
    { land_size: '70 ha' },
    { land_size: '80 ha' },
    { land_size: '90 ha' },
    { land_size: '100 ha' },
    { land_size: '150 ha' },
    { land_size: '200 ha' },
    { land_size: '300 ha' },
    { land_size: '500 ha' },
    { land_size: '1000 ha' },
    { land_size: '3000 ha' },
    { land_size: '5000 ha' },
    { land_size: '10000 ha' },
  ];

  public static marketPricing = [
    { price: 'Any' },
    { price: '$250,000' },
    { price: '$500,000' },
    { price: '$750,000' },
    { price: '$1,000,000' },
    { price: '$1,250,000' },
    { price: '$1,500,000' },
    { price: '$1,750,000' },
    { price: '$2,000,000' },
    { price: '$2,250,000' },
    { price: '$2,500,000' },
    { price: '$2,750,000' },
    { price: '$3,000,000' },
    { price: '$3,250,000' },
    { price: '$3,500,000' },
    { price: '$3,750,000' },
    { price: '$4,000,000' },
    { price: '$4,250,000' },
    { price: '$4,500,000' },
    { price: '$4,750,000' },
    { price: '$5,000,000' },
  ];

  public static marketRentPricing = [
    { price: 'Any' },
    { price: '$50' },
    { price: '$100' },
    { price: '$150' },
    { price: '$200' },
    { price: '$250' },
    { price: '$300' },
    { price: '$350' },
    { price: '$400' },
    { price: '$450' },
    { price: '$500' },
    { price: '$550' },
    { price: '$600' },
    { price: '$650' },
    { price: '$700' },
    { price: '$750' },
    { price: '$800' },
    { price: '$850' },
    { price: '$900' },
    { price: '$950' },
    { price: '$1000' },
    { price: '$1100' },
    { price: '$1200' },
    { price: '$1300' },
    { price: '$1400' },
    { price: '$1500' },
    { price: '$1600' },
    { price: '$1700' },
    { price: '$1800' },
    { price: '$1900' },
    { price: '$2000' },
    { price: '$2500' },
    { price: '$3000' },
    { price: '$3500' },
    { price: '$4000' },
    { price: '$4500' },
    { price: '$5000' },
  ];

  public static timer_options = [
    '8am',
    '8:30am',
    '9am',
    '9:30am',
    '10am',
    '10:30am',
    '11am',
    '11:30am',
    '12pm',
    '12:30pm',
    '1pm',
    '1:30pm',
    '2pm',
    '2:30pm',
    '3pm',
    '3:30pm',
    '4pm',
    '4:30pm',
    '5pm',
    '5:30pm',
    '6pm',
    '6:30pm',
    '7pm',
    '7:30pm',
    '8pm',
    '8:30pm',
    '9pm',
    '9:30pm',
    '10pm',
    '10:30pm',
    '11pm',
    '11:30pm',
    '12am',
    '12:30am',
    '1am',
    '1:30pm',
    '2am',
    '2:30am',
    '3am',
    '3:30am',
    '4am',
    '4:30am',
    '5am',
    '5:30am',
    '6am',
    '6:30am',
    '7am',
    '7:30am',
  ];

  public static timer_options_new = [
    { label: '8am', value: '08:00am' },
    { label: '8:30am', value: '08:30am' },
    { label: '9am', value: '09:00am' },
    { label: '9:30am', value: '09:30am' },
    { label: '10am', value: '10:00am' },
    { label: '10:30am', value: '10:30am' },
    { label: '11am', value: '11:00am' },
    { label: '11:30am', value: '11:30am' },
    { label: '12pm', value: '12:00pm' },
    { label: '12:30pm', value: '12:30pm' },
    { label: '1pm', value: '01:00pm' },
    { label: '1:30pm', value: '01:30pm' },
    { label: '2pm', value: '02:00pm' },
    { label: '2:30pm', value: '02:30pm' },
    { label: '3pm', value: '03:00pm' },
    { label: '3:30pm', value: '03:30pm' },
    { label: '4pm', value: '04:00pm' },
    { label: '4:30pm', value: '04:30pm' },
    { label: '5pm', value: '05:00pm' },
    { label: '5:30pm', value: '05:30pm' },
    { label: '6pm', value: '06:00pm' },
    { label: '6:30pm', value: '06:30pm' },
    { label: '7pm', value: '07:00pm' },
    { label: '7:30pm', value: '07:30pm' },
    { label: '8pm', value: '08:00pm' },
    { label: '8:30pm', value: '08:30pm' },
    { label: '9pm', value: '09:00pm' },
    { label: '9:30pm', value: '09:30pm' },
    { label: '10pm', value: '10:00pm' },
    { label: '10:30pm', value: '10:30pm' },
    { label: '11pm', value: '11:00pm' },
    { label: '11:30pm', value: '11:30pm' },
    { label: '12am', value: '12:00am' },
    { label: '12:30am', value: '12:30am' },
    { label: '1am', value: '01:00am' },
    { label: '1:30am', value: '01:30am' },
    { label: '2am', value: '02:00am' },
    { label: '2:30am', value: '02:30am' },
    { label: '3am', value: '03:00am' },
    { label: '3:30am', value: '03:30am' },
    { label: '4am', value: '04:00am' },
    { label: '4:30am', value: '04:30am' },
    { label: '5am', value: '05:00am' },
    { label: '5:30am', value: '05:30am' },
    { label: '6am', value: '06:00am' },
    { label: '6:30am', value: '06:30am' },
    { label: '7am', value: '07:00am' },
    { label: '7:30am', value: '07:30am' },
  ];

  public static reminder_options = [
    'none',
    '0 minutes',
    '5 minutes',
    '10 minutes',
    '15 minutes',
    '30 minutes',
    '1 hour',
    '2 hours',
    '3 hours',
    '4 hours',
    '5 hours',
    '6 hours',
    '7 hours',
    '8 hours',
    '9 hours',
    '10 hours',
    '11 hours',
    '0.5 days',
    '18 hours',
    '1 day',
    '2 days',
    '3 days',
    '4 days',
    '1 week',
    '2 weeks',
  ];
}
